import { Cookies } from "react-cookie";

const cookie = new Cookies();

const getCookie = (name: string) => {
  const cookieValue = cookie.get(name);
  return cookieValue;
};

const setCookie = (
  name: string,
  value: any,
  options?: Record<string, unknown>,
) => {
  options ? cookie.set(name, value, options) : cookie.set(name, value);
};
// const setCookie = (
//   name: string,
//   value: any,
//   options?: Record<string, unknown>,
// ) => {
//   const defaultOptions = {
//     path: "/",
//     sameSite: "none" as const,
//     secure: true,
//   };

//   options
//     ? cookie.set(name, value, { ...options, ...defaultOptions }) // proširi postojeće
//     : cookie.set(name, value, defaultOptions); // koristi samo default
// };

const removeFromCookie = (name: string, options?: Record<string, unknown>) => {
  options ? cookie.remove(name, options) : cookie.remove(name);
};
// const removeFromCookie = (name: string, options?: Record<string, unknown>) => {
//   const defaultOptions = {
//     path: "/",
//     sameSite: "none" as const,
//     secure: true,
//   };

//   const finalOptions = options
//     ? { ...options, ...defaultOptions }
//     : defaultOptions;

//   cookie.remove(name, finalOptions);
// };

export { getCookie, removeFromCookie, setCookie };
